import { ApiConfig, tokenService, SportsDataApiClient } from "sbtech-sports-data-api-client";
import { SportDataGatewayConfig } from "../../SportData";
import { GlobalConfig } from "../../configuration";
export { entities } from "sbtech-sports-data-api-client";
/**
 * SportDataGateway class provides interface for communication between sports data service and blocks though sports data client.
 */
var SportDataGateway = /** @class */ (function () {
    /**
    * Creates an instance of SportDataGateway
    * SportsDataGatewayConfig should be initialized before this constructor
    **/
    function SportDataGateway() {
        this.gatewayConfig = new SportDataGatewayConfig(GlobalConfig.apiConfigs.sportDataApiUrl);
        this.setAuthToken();
        this.client = new SportsDataApiClient(this.getApiConfig());
    }
    SportDataGateway.prototype.setAuthToken = function () {
        this.gatewayConfig.authToken = GlobalConfig.getAuthorization().token;
        if (this.gatewayConfig.authToken) {
            tokenService.apiAccessToken = this.gatewayConfig.authToken;
        }
        ;
    };
    /**
     * Activate method does nothing and has beed added for consistency
    */
    SportDataGateway.prototype.activate = function () {
    };
    /**
     * Pulls data from sports data API for entity of type "Event".
     * @param {SportDataGatewayQueryInfo<EventPayload>} queryInfo query sports data client
     * In case of pulling events from sportsData API you can get 2 arrays markets and events this
     * is why the Payload is diferent
    */
    SportDataGateway.prototype.pullEvents = function (queryInfo) {
        var query = this.getQuery(queryInfo);
        this.client.events.pull(query)
            .then(function (res) { return queryInfo.onMessageHandler(res.data); })
            .catch(function (ex) { return queryInfo.onErrorHandler && queryInfo.onErrorHandler(ex); });
    };
    /**
     * Pulls data from sports data API for entity of type "Market".
     * @param {SportDataGatewayQueryInfo<entities.Market[]>} queryInfo query sports data client
    */
    SportDataGateway.prototype.pullMarkets = function (queryInfo) {
        var query = this.getQuery(queryInfo);
        this.client.markets.pull(query)
            .then(function (res) { return queryInfo.onMessageHandler(res.data); })
            .catch(function (ex) { return queryInfo.onErrorHandler && queryInfo.onErrorHandler(ex); });
    };
    /**
     * Pulls data from sports data API for entity of type "League".
     * @param {SportDataGatewayQueryInfo<entities.League[]>} queryInfo query sports data client
    */
    SportDataGateway.prototype.pullLeagues = function (queryInfo) {
        var query = this.getQuery(queryInfo);
        this.client.leagues.pull(query)
            .then(function (res) { return queryInfo.onMessageHandler(res.data); })
            .catch(function (ex) { return queryInfo.onErrorHandler && queryInfo.onErrorHandler(ex); });
    };
    /**
     * Pulls data from sports data API for entity of type "Region".
     * @param {SportDataGatewayQueryInfo<entities.Region[]>} queryInfo query sports data client
    */
    SportDataGateway.prototype.pullRegions = function (queryInfo) {
        var query = this.getQuery(queryInfo);
        this.client.regions.pull(query)
            .then(function (res) { return queryInfo.onMessageHandler(res.data); })
            .catch(function (ex) { return queryInfo.onErrorHandler && queryInfo.onErrorHandler(ex); });
    };
    /**
     * Pulls data from sports data API for entity of type "Sport".
     * @param {SportDataGatewayQueryInfo<entities.Sport[]>} queryInfo query sports data client
    */
    SportDataGateway.prototype.pullSports = function (queryInfo) {
        var query = this.getQuery(queryInfo);
        this.client.sports.pull(query)
            .then(function (res) { return queryInfo.onMessageHandler(res.data); })
            .catch(function (ex) { return queryInfo.onErrorHandler && queryInfo.onErrorHandler(ex); });
    };
    /**
     * Pulls data from sports data API for entity of type "GameIncidets".
     * @param {PullGameIncidentsQueryInfo} queryInfo query sports data client
    */
    SportDataGateway.prototype.pullGameIncidents = function (queryInfo) {
        this.client.gameIncidents.pull(queryInfo.eventIds, queryInfo.incidentTypes, queryInfo.top, queryInfo.skip)
            .then(function (res) { return queryInfo.onMessageHandler(res.data); })
            .catch(function (ex) { return queryInfo.onErrorHandler && queryInfo.onErrorHandler(ex); });
    };
    /**
     * Subscribes for snapshots/updates from sports data API for entity of type "Event".
     * @param {SportDataGatewayQueryInfo<EventPushResponse>} queryInfo query sports data client
    */
    SportDataGateway.prototype.subscribeForEvents = function (queryInfo) {
        var query = this.getQuery(queryInfo);
        return this.client.events.subscribe(query, queryInfo.onMessageHandler, queryInfo.onErrorHandler);
    };
    /**
     * Subscribes for snapshots/updates from sports data API for entity of type "Market".
     * @param {SportDataGatewayQueryInfo<EntityPushResponse<entities.Market, entities.MarketChange>>} queryInfo query sports data client
    */
    SportDataGateway.prototype.subscribeForMarkets = function (queryInfo) {
        var query = this.getQuery(queryInfo);
        return this.client.markets.subscribe(query, queryInfo.onMessageHandler, queryInfo.onErrorHandler);
    };
    /**
     * Subscribes for snapshots/updates from sports data API for entity of type "League".
     * @param {SportDataGatewayQueryInfo<EntityPushResponse<entities.League, entities.LeagueChange>>} queryInfo query sports data client
     */
    SportDataGateway.prototype.subscribeForLeagues = function (queryInfo) {
        var query = this.getQuery(queryInfo);
        return this.client.leagues.subscribe(query, queryInfo.onMessageHandler, queryInfo.onErrorHandler);
    };
    /**
     * Subscribes for snapshots/updates from sports data API for entity of type "Region".
     * @param {SportDataGatewayQueryInfo<EntityPushResponse<entities.Region, entities.RegionChange>>} queryInfo query sports data client
    */
    SportDataGateway.prototype.subscribeForRegions = function (queryInfo) {
        var query = this.getQuery(queryInfo);
        return this.client.regions.subscribe(query, queryInfo.onMessageHandler, queryInfo.onErrorHandler);
    };
    /**
     * Subscribes for snapshots/updates from sports data API for entity of type "Sport".
     * @param {SportDataGatewayQueryInfo<EntityPushResponse<entities.Sport, entities.SportChange>>} queryInfo query sports data client
    */
    SportDataGateway.prototype.subscribeForSports = function (queryInfo) {
        var query = this.getQuery(queryInfo);
        return this.client.sports.subscribe(query, queryInfo.onMessageHandler, queryInfo.onErrorHandler);
    };
    /**
     * @deprecated since sports data api client version [0.12.0] - 2019-08-01. Use pullGameIncidents and subscribeForGameIncidents endpoints.
     * Subscribe for snapshots/updates from sports data API for entity of type "Incidents".
     * @param {SportDataGatewayQueryInfo<EntityPushResponse<entities.Incident, entities.Incident>>} queryInfo query sports data client
     */
    SportDataGateway.prototype.subscribeForIncidents = function (queryInfo) {
        var query = this.getQuery(queryInfo);
        return this.client.incidents.subscribe(query, queryInfo.onMessageHandler, queryInfo.onErrorHandler);
    };
    /**
     * Subscribe for snapshots/updates from sports data API for entity of type "GameIncident".
     * @param {SubscribeGameIncidentsQueryInfo} queryInfo query sports data client
     */
    SportDataGateway.prototype.subscribeForGameIncidents = function (queryInfo) {
        return this.client.gameIncidents.subscribe(queryInfo.eventIds, queryInfo.onMessageHandler, queryInfo.onErrorHandler, queryInfo.incidentTypes);
    };
    SportDataGateway.prototype.getApiConfig = function () {
        var apiUrl = this.gatewayConfig.serviceUrl + this.gatewayConfig.apiEndpoint;
        return new ApiConfig(apiUrl);
    };
    SportDataGateway.prototype.getQuery = function (queryInfo) {
        var query = {
            query: queryInfo.query,
            locale: queryInfo.locale || GlobalConfig.apiConfigs.locale,
            params: {
                initialData: queryInfo.initialData,
                from: queryInfo.from,
                until: queryInfo.until,
                timeRange: queryInfo.timeRange,
                includeMarkets: queryInfo.includeMarkets,
                projection: queryInfo.projection,
                format: "ODataV3"
            }
        };
        return query;
    };
    return SportDataGateway;
}());
export { SportDataGateway };
//# sourceMappingURL=SportDataGateway.js.map